
<template>
  <v-card class="filter-data-card pa-0 ma-0"  flat rounded="lg" elevation="0">
    <v-card-title class="filter-data-head pb-2">
      <div class="d-flex align-center flex-grow-1 flex-wrap" style="gap: 12px;">
        <v-avatar color="primary" size="40" tile class="rounded-lg">
          <v-icon dark>mdi-tune</v-icon>
        </v-avatar>
        <div class="filter-data-head-text">
          <div class="filter-data-title">Filtros</div>
          <div class="filter-data-subtitle text--secondary">Refine os dados e clique em aplicar</div>
        </div>
        <v-spacer class="d-none d-md-flex" />
        <v-btn
          class="filter-data-btn"
          :class="{ 'ml-md-2': true }"
          :block="$vuetify.breakpoint.smAndDown"
          :disabled="loading_block"
          color="primary"
          depressed
          rounded
          large
          @click="emitFilter()"
        >
          <v-icon left>mdi-filter-variant</v-icon>
          Aplicar filtros
        </v-btn>
      </div>
    </v-card-title>

    <v-divider class="filter-data-divider" />

    <v-card-text class="pt-5 pb-2 px-4 px-sm-6">
      <v-form ref="form" @submit.prevent="emitFilterOnEnter">
        <v-row dense>
          <slot name="extra-filters" />

          <v-col v-if="withBillSituationSelect" cols="12" :md="fieldMd('bill_situation')">
            <v-select
              v-model="bill_situation_internal"
              :items="billSituationItems"
              item-text="text"
              return-object
              outlined
              dense
              hide-details="auto"
              :prepend-inner-icon="billSituationIcon"
              :label="billSituationLabel"
            />
          </v-col>

          <v-col v-if="withExchangeSituationSelect" cols="12" :md="fieldMd('exchange_situation')">
            <v-select
              v-model="exchange_status_internal"
              :items="exchangeSituationItems"
              item-text="text"
              item-value="value"
              multiple
              chips
              small-chips
              outlined
              dense
              hide-details="auto"
              :prepend-inner-icon="exchangeSituationIcon"
              :label="exchangeSituationLabel"
            />
          </v-col>

          <v-col v-if="withDepositSituationSelect" cols="12" :md="fieldMd('deposit_situation')">
            <v-select
              v-model="deposit_status_internal"
              :items="depositSituationItems"
              item-text="text"
              item-value="value"
              multiple
              chips
              small-chips
              outlined
              dense
              hide-details="auto"
              :prepend-inner-icon="depositSituationIcon"
              :label="depositSituationLabel"
            />
          </v-col>

          <v-col v-if="withVrtSituationSelect" cols="12" :md="fieldMd('vrt_situation')">
            <v-select
              v-model="vrt_status_internal"
              :items="vrtSituationItems"
              item-text="text"
              item-value="value"
              multiple
              chips
              small-chips
              outlined
              dense
              hide-details="auto"
              :prepend-inner-icon="vrtSituationIcon"
              :label="vrtSituationLabel"
            />
          </v-col>

          <v-col v-if="with_pix_status" cols="12" :md="fieldMd('pix_status')">
            <v-select
              v-model="selected_pix_statuses"
              multiple
              chips
              small-chips
              outlined
              dense
              hide-details="auto"
              :items="pix_statuses"
              item-text="text"
              item-value="value"
              prepend-inner-icon="mdi-list-status"
              label="Status dos PIX"
            />
          </v-col>

          <v-col v-if="with_client_portfolios" cols="12" :md="fieldMd('client_portfolio')">
            <v-autocomplete
              v-model="selected_client_portfolio_id"
              :loading="loading.client_portfolios"
              clearable
              outlined
              dense
              hide-details="auto"
              :items="client_portfolios"
              item-text="attributes.name"
              item-value="id"
              prepend-inner-icon="mdi-wallet"
              label="Carteira de clientes"
            />
          </v-col>

          <v-col v-if="with_client" cols="12" :md="fieldMd('client')">
            <v-autocomplete
              v-model="selected_clients"
              :loading="loading.clients"
              multiple
              chips
              small-chips
              outlined
              dense
              hide-details="auto"
              :items="clients"
              :item-text="formatClientDisplayName"
              item-value="id"
              prepend-inner-icon="mdi-account-outline"
              label="Cliente"
              :filter="filterClients"
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title class="pb-1">
                    <span v-if="item.id">Nome / Razão social:</span>
                    <strong>{{ formatClientDisplayName(item) }}</strong>
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="item.fantasyName && item.fantasyName != item.name" class="mb-1">
                    Nome fantasia: <strong>{{ item.fantasyName }}</strong>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.id" class="d-flex justify-space-between">
                    <span>ID: <strong>{{ item.id }}</strong></span>
                    <span>Cidade: <strong>{{ item.city }}</strong></span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col v-if="with_date_start" cols="12" :md="fieldMd('date_start')">
            <v-dialog ref="dialogStart" v-model="modalStart" :return-value.sync="date_start" persistent width="320">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  outlined
                  dense
                  readonly
                  hide-details="auto"
                  prepend-inner-icon="mdi-calendar"
                  :value="$moment(date_start).add(12, 'hour').format('DD/MM/YYYY')"
                  label="Data inicial"
                  :rules="dateFieldRules"
                />
              </template>
              <v-date-picker
                v-model="date_start"
                color="primary"
                header-color="primary"
                locale="pt-br"
                scrollable
                :max="pickerStartMax"
                :min="pickerStartMin"
              >
                <v-spacer />
                <v-btn text @click="modalStart = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.dialogStart.save(date_start)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col v-if="with_date_end" cols="12" :md="fieldMd('date_end')">
            <v-dialog ref="dialogEnd" v-model="modalEnd" :return-value.sync="date_end" persistent width="320">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  outlined
                  dense
                  readonly
                  hide-details="auto"
                  prepend-inner-icon="mdi-calendar"
                  :value="$moment(date_end).add(12, 'hour').format('DD/MM/YYYY')"
                  label="Data final"
                  :rules="dateFieldRules"
                />
              </template>
              <v-date-picker
                v-model="date_end"
                color="primary"
                header-color="primary"
                locale="pt-br"
                scrollable
                :min="pickerEndMin"
                :max="pickerEndMax"
              >
                <v-spacer />
                <v-btn text @click="modalEnd = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.dialogEnd.save(date_end)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col v-if="with_sellers" cols="12" :md="fieldMd('sellers')">
            <v-select
              v-model="selected_sellers"
              :loading="loading.sellers"
              multiple
              chips
              small-chips
              outlined
              dense
              hide-details="auto"
              :items="sellers"
              item-text="name"
              item-value="id"
              prepend-inner-icon="mdi-account-tie"
              label="Vendedores"
            />
          </v-col>

          <v-col v-if="with_company" cols="12" :md="fieldMd('company')">
            <v-select
              v-model="selected_companies"
              multiple
              chips
              small-chips
              outlined
              dense
              hide-details="auto"
              :items="companies"
              item-text="attributes.name"
              item-value="attributes.name"
              prepend-inner-icon="mdi-domain"
              label="Empresas"
            />
          </v-col>

          <v-col v-if="with_brand" cols="12" :md="fieldMd('brand')">
            <v-select
              v-model="selected_brands"
              multiple
              chips
              small-chips
              outlined
              dense
              hide-details="auto"
              :items="brands"
              item-text="name"
              item-value="id"
              prepend-inner-icon="mdi-factory"
              label="Marcas"
            />
          </v-col>

          <v-col v-if="with_bank" cols="12" :md="fieldMd('bank')">
            <v-select
              v-model="selected_banks"
              multiple
              chips
              small-chips
              outlined
              dense
              hide-details="auto"
              :items="wich_banks"
              item-text="name"
              item-value="id"
              prepend-inner-icon="mdi-bank"
              label="Bancos"
            />
          </v-col>

          <v-col v-if="with_payment_option" cols="12" :md="fieldMd('payment_option')">
            <v-select
              v-model="selected_payment_options"
              multiple
              chips
              small-chips
              outlined
              dense
              hide-details="auto"
              :items="payment_options"
              item-text="attributes.description"
              item-value="id"
              prepend-inner-icon="mdi-credit-card-outline"
              label="Formas de pagamento"
            />
          </v-col>

          <v-col v-if="with_envelope_number" cols="12" :md="fieldMd('envelope_number')">
            <v-text-field
              v-model="envelope_number"
              outlined
              dense
              hide-details="auto"
              prepend-inner-icon="mdi-email-outline"
              label="Número do envelope"
              @keydown.enter.prevent="emitFilterOnEnter"
            />
          </v-col>

          <v-col v-if="with_text_search" cols="12" :md="fieldMd('text_search')">
            <v-text-field
              v-model="text_search"
              outlined
              dense
              clearable
              hide-details="auto"
              prepend-inner-icon="mdi-magnify"
              :label="text_search_label"
              @keydown.enter.prevent="emitFilterOnEnter"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import Api from '../../api/index'
import clientDisplay from '@/mixins/clientDisplay'

export default {
  name: 'FilterData',
  mixins: [clientDisplay],
  props: {
    // SEMPRE PRESENTES
    loading_block: {
      type: Boolean,
      default: false
    },
    with_client: {
      type: Boolean,
      default: true
    },
    with_date_start: {
      type: Boolean,
      default: true
    },
    with_date_end: {
      type: Boolean,
      default: true
    },
    // PARCIAIS
    with_sellers: {
      type: Boolean,
      default: false
    },
    with_client_portfolios: {
      type: Boolean,
      default: false
    },
    with_company: {
      type: Boolean,
      default: false
    },
    // UNICOS
    with_pix_status: {
      type: Boolean,
      default: false
    },
    with_brand: {
      type: Boolean,
      default: false
    },
    with_payment_option: {
      type: Boolean,
      default: false
    },
    with_bank: {
      type: Boolean,
      default: false
    },
    with_envelope_number: {
      type: Boolean,
      default: false
    },
    with_text_search: {
      type: Boolean,
      default: false
    },
    text_search_label: {
      type: String,
      default: 'Pesquisar'
    },
    with_company_banks: {
      type: Boolean,
      default: false
    },
    without_active_depot: {
      type: Boolean,
      default: false
    },
    months_before: { // desabilitado
      type: [String, Number],
      default: 2
    },
    months_after: {
      type: [String, Number], // desabilitado
      default: 1
    },
    limit_date_end:{
      type: String,
      default: null
    },
    max_limit_date_end:{
      type: String,
      default: null
    },
    min_limit_date_start:{
      type: String,
      default: null
    },
    limit_date_start:{
      type: String,
      default: null
    },
    /** Quando informados, substituem min/max nativos dos date pickers (ex.: cheques custódia x compensados). */
    initial_date_start: {
      type: String,
      default: null
    },
    initial_date_end: {
      type: String,
      default: null
    },
    start_date_min: {
      type: String,
      default: null
    },
    start_date_max: {
      type: String,
      default: null
    },
    end_date_min: {
      type: String,
      default: null
    },
    end_date_max: {
      type: String,
      default: null
    },
    /** Se true, não aplica a regra de intervalo máximo entre data inicial e final (ex.: intervalo de anos). */
    skip_date_range_rule: {
      type: Boolean,
      default: false
    },

    /** Boletos: situação (abertos / concluídos / cancelados). Itens `{ text, value }` com `value` = `{ by_concluded, status_ids }`. Use `return-object` no select. */
    withBillSituationSelect: {
      type: Boolean,
      default: false
    },
    billSituationItems: {
      type: Array,
      default: () => []
    },
    billSituationValue: {
      type: Object,
      default: null
    },
    billSituationLabel: {
      type: String,
      default: 'Boletos'
    },
    billSituationIcon: {
      type: String,
      default: 'mdi-barcode'
    },

    /** Permutas: `by_status` (múltiplo). Itens `{ text, value }` com `value` numérico. */
    withExchangeSituationSelect: {
      type: Boolean,
      default: false
    },
    exchangeSituationItems: {
      type: Array,
      default: () => []
    },
    exchangeSituationValue: {
      type: Array,
      default: () => []
    },
    exchangeSituationLabel: {
      type: String,
      default: 'Permutas'
    },
    exchangeSituationIcon: {
      type: String,
      default: 'mdi-swap-horizontal'
    },

    /** Depósitos: `status_ids` (múltiplo). Itens `{ text, value }` numérico. */
    withDepositSituationSelect: {
      type: Boolean,
      default: false
    },
    depositSituationItems: {
      type: Array,
      default: () => []
    },
    depositSituationValue: {
      type: Array,
      default: () => []
    },
    depositSituationLabel: {
      type: String,
      default: 'Depósitos'
    },
    depositSituationIcon: {
      type: String,
      default: 'mdi-cash-fast'
    },

    /** Faturas a receber: `by_status_ids` (múltiplo). Itens `{ text, value }` string. */
    withVrtSituationSelect: {
      type: Boolean,
      default: false
    },
    vrtSituationItems: {
      type: Array,
      default: () => []
    },
    vrtSituationValue: {
      type: Array,
      default: () => []
    },
    vrtSituationLabel: {
      type: String,
      default: 'Pagamentos'
    },
    vrtSituationIcon: {
      type: String,
      default: 'mdi-credit-card-settings-outline'
    },
    /** Quantidade de filtros extras renderizados no slot `extra-filters` para compor layout responsivo. */
    extraFiltersCount: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      clients: [],
      client_portfolios: [],
      date_start: this.$moment().subtract(this.months_before, 'month').startOf('month').format('YYYY-MM-DD'),
      date_end: this.$moment().add(this.months_after, 'month').endOf('month').format('YYYY-MM-DD'),
      sellers: [],
      companies: [],
      brands: [],
      banks: [],
      pix_statuses: [
        { value: "pending", text: "Pendente" },
        { value: "approved", text: "Pago" },
        { value: "partial_refunded", text: "Estornado parcial" },
        { value: "refunded", text: "Estornado" },
        { value: "refund_pending", text: "Estorno pendente" },
        { value: "cancelled", text: "Cancelado" },
        { value: "pendingv", text: "Pendente (variável)" },
        { value: "expired", text: "Expirado" },
      ],
      company_banks: ['Itaú','Sicoob','Caixa','Banco do Brasil'],
      envelope_number: null,
      text_search: '',

      loading: {
        clients: false,
        client_portfolios: false,
        sellers: false,
        companies: false,
        brands: false,
        banks: false,
        pix_statuses: false,
        payment_options: false,
      },

      selected_clients: [null],
      selected_client_portfolio_id: null,
      selected_sellers: [],
      selected_companies: [],
      selected_brands: [null],
      selected_banks: [null],
      selected_payment_options: [],
      payment_options: [],
      selected_pix_statuses: [],

      modalStart: false,
      modalEnd: false,

      bill_situation_internal: null,
      exchange_status_internal: [],
      deposit_status_internal: [],
      vrt_status_internal: [],
    }
  },
  created() {
    if (this.initial_date_start) {
      this.date_start = this.initial_date_start
    }
    if (this.initial_date_end) {
      this.date_end = this.initial_date_end
    }
    this.syncSituationModelsFromProps()
  },
  methods: {
    fieldMd(key) {
      const idx = this.visibleFilterKeys.indexOf(key)
      if (idx < 0) return 6
      const isLast = idx === this.visibleFilterKeys.length - 1
      const hasOddVisibleCount = this.visibleFilterKeys.length % 2 === 1
      return isLast && hasOddVisibleCount ? 12 : 6
    },
    syncSituationModelsFromProps() {
      if (this.withBillSituationSelect && this.billSituationValue) {
        const v = this.billSituationValue
        const found = (this.billSituationItems || []).find(
          (it) =>
            it.value &&
            it.value.by_concluded === v.by_concluded &&
            JSON.stringify(it.value.status_ids || []) === JSON.stringify(v.status_ids || [])
        )
        this.bill_situation_internal = found ? { text: found.text, value: { ...found.value } } : { text: '', value: { ...v } }
      }
      if (this.withExchangeSituationSelect) {
        this.exchange_status_internal = [...(this.exchangeSituationValue || [])]
      }
      if (this.withDepositSituationSelect) {
        this.deposit_status_internal = [...(this.depositSituationValue || [])]
      }
      if (this.withVrtSituationSelect) {
        this.vrt_status_internal = [...(this.vrtSituationValue || [])]
      }
    },
    resetItems(){
      this.clients = []
      this.client_portfolios = []
      this.sellers = []
      this.companies = []
      this.brands = []
      this.banks = []
      this.selected_clients = [null]
      this.selected_client_portfolio_id = null
      this.selected_sellers = []
      this.selected_companies = []
      this.selected_brands = []
      this.selected_banks = []
      this.selected_pix_statuses = []
      this.envelope_number = null
      this.selected_pix_statuses = null
      this.text_search = ''
    },
    buildFilterPayload() {
      const filter = {}
      if (this.with_client_portfolios && this.selected_client_portfolio_id) {
        filter.portfolio_id = this.selected_client_portfolio_id
      }
      if (this.with_client){
        filter.clients = this.selected_clients.filter(i => i)
      }
      if (this.with_date_start){
        filter.start_date = this.$moment(this.date_start).startOf('day').format()
      }
      if (this.with_date_end){
        filter.end_date = this.$moment(this.date_end).endOf('day').format()
      }
      if (this.with_sellers){
        filter.sellers = this.selected_sellers.filter(i => i)
      }
      if (this.with_company){
        filter.companies = this.selected_companies
      }
      if (this.with_brand){
        filter.brands = this.selected_brands.filter(i => i)
      }
      if (this.with_bank){
        filter.banks = this.selected_banks.filter(i => i)
      }
      if (this.with_envelope_number){
        filter.envelope_number = this.envelope_number
      }
      if (this.with_pix_status){
        filter.by_pix_statuses = this.selected_pix_statuses
      }
      if (this.with_payment_option){
        filter.payment_options = this.selected_payment_options
      }
      if (this.with_text_search && this.text_search && String(this.text_search).trim()) {
        filter.query = String(this.text_search).trim()
      }
      if (this.withBillSituationSelect && this.bill_situation_internal) {
        const inner = this.bill_situation_internal.value != null
          ? this.bill_situation_internal.value
          : this.bill_situation_internal
        if (inner && inner.by_concluded !== undefined) {
          filter.by_concluded = inner.by_concluded
          filter.status_ids = [...(inner.status_ids || [])]
        }
      }
      if (this.withExchangeSituationSelect) {
        filter.by_status = [...(this.exchange_status_internal || [])]
      }
      if (this.withDepositSituationSelect) {
        filter.status_ids = [...(this.deposit_status_internal || [])]
      }
      if (this.withVrtSituationSelect) {
        filter.by_status_ids = [...(this.vrt_status_internal || [])]
      }
      return filter
    },
    syncAppliedPortfolioToVuex(payload) {
      if (!this.with_client_portfolios) return
      const portfolioId = payload && payload.portfolio_id ? payload.portfolio_id : null
      this.setSelectedPortfolioInVuex(portfolioId)
    },
    emitFilter() {
      if (this.$refs.form.validate()) {
        const payload = this.buildFilterPayload()
        this.syncAppliedPortfolioToVuex(payload)
        this.$emit('doneFilter', payload)
      }
    },
    emitFilterOnEnter() {
      if (this.loading_block) return
      this.emitFilter()
    },
    emitFilterPayload() {
      const payload = this.buildFilterPayload()
      this.syncAppliedPortfolioToVuex(payload)
      this.$emit('doneFilter', payload)
    },
    getClients(){
      let filter = {}
      if (this.isSeller()){
        filter = { only_employee_clients: true, employee_id: this.current_user_employee_id, short: true }
      } else {
        filter = {
          modality_id: this.activeModalityId, 
          // solution: 'retail',
          short: true,
        }
      }
      this.loading.clients = true
      Api.Client.index(filter).then(r=>r.data).then(d=>{
        d = d.data? d.data.map(c=>c.attributes) : d
        this.clients = [{corporateName: 'TODOS', id: null}, ...d]
      }).finally(()=>{
        this.loading.clients = false
      })
    },
    getSellers(){
      let filters = {
        modality_ids: this.without_active_depot? null : [this.activeModalityId],
        // by_role: 'Seller, Manager, Supervisor, Clerk',
        by_roles: ['Seller', 'Manager', 'Supervisor', 'Clerk'],
      }
      // index_params[:by_role], by_modality_ids: index_params[:by_modality_ids
      this.loading.sellers = true
      Api.Employee.index(filters).then(r=>r.data).then(e =>{
        e = e.data? e.data.map(em=> em.attributes) : e
        this.sellers = [{name: 'TODOS', id: null}, ...e]
      }).finally(()=>{
        this.loading.sellers = false
      })
    },
    getCompanies(){
      this.loading.companies = true
      let filter = {short: true}
      Api.Company.index(filter).then(r => r.data).then(res => {
        this.companies = [...res.data]
      }).finally(()=>{
        this.loading.companies = false
      })
    },
    getBrands(){
      this.loading.brands = true
      Api.Supplier.indexBrand({only_brands: true}).then(r=>r.data).then(d=>{
        d = d.data? d.data.map(da=> da.attributes) : d
        this.brands = [{name: 'TODOS', id: null}, ...d]
      }).finally(()=>{
        this.loading.brands = false
      })
    },
    getBanks(){
      this.loading.banks = true
      Api.Bank.index().then(r => r.data).then(d => {
        d = d.data? d.data.map(da=> da.attributes) : d
        this.banks = [{name: 'TODOS', id: null}, ...d]
      }).finally(() => {
        this.loading.banks = false
      });
    },
    getPaymentsMethods(){
      this.loading.payment_options = true
      Api.PaymentOption.index("options").then(r => r.data).then(res => {
        res = res.data? res.data : res
        this.payment_options = [...res]
      }).finally(() => {
        this.loading.payment_options = false
      });
    },
    getClientPortfolios(){
      this.loading.client_portfolios = true
      const filter = {}
      if (this.activeModalityId && this.activeModalityId > 0) {
        filter.modality_id = this.activeModalityId
      }
      Api.ClientPortfolio.index(filter).then(r => r.data).then((data) => {
        this.client_portfolios = [
          { id: null, attributes: { name: 'Todas as carteiras' } },
          ...(data.data || []),
        ]
      }).finally(() => {
        this.loading.client_portfolios = false
      })
    },
    getNeededData() {
      if( this.activeModalityId ){
        if (this.with_client_portfolios){
          this.getClientPortfolios()
        }
        if (this.with_client){
          this.getClients()
        }
        if (this.with_sellers){
          this.getSellers()
        }
        if (this.with_company){
          this.getCompanies()
        }
        if (this.with_brand){
          this.getBrands()
        }
        if (this.with_bank){
          this.getBanks()
        }
        if( this.with_payment_option){
          this.getPaymentsMethods()
        }
      }
    },
    filterClients (item, queryText, itemText) {
      const name = item.name ? item.name.toLowerCase() : ''
      const corporate_name = item.corporateName ? item.corporateName.toLowerCase() : ''
      const fantasyName = item.fantasyName ? item.fantasyName.toLowerCase() : ''
      const city = item.city ? item.city.toLowerCase() : ''
      const id = item.id ? item.id.toString() : ''
      const searchText = queryText.toLowerCase()

      return name.indexOf(searchText) > -1 || corporate_name.indexOf(searchText) > -1 || fantasyName.indexOf(searchText) > -1 || city.indexOf(searchText) > -1 || id.indexOf(searchText) > -1
    },
    ...mapActions({
      setSelectedPortfolioInVuex: 'ClientPortfolio/setSelectedPortfolio',
    }),
  },
  mounted() {
    this.getNeededData()
    this.$nextTick(() => {
      this.emitFilterPayload()
    })
  },
  computed: {
    visibleFilterKeys() {
      const keys = []
      for (let i = 0; i < this.extraFiltersCount; i++) {
        keys.push(`extra_${i}`)
      }
      if (this.withBillSituationSelect) keys.push('bill_situation')
      if (this.withExchangeSituationSelect) keys.push('exchange_situation')
      if (this.withDepositSituationSelect) keys.push('deposit_situation')
      if (this.withVrtSituationSelect) keys.push('vrt_situation')
      if (this.with_pix_status) keys.push('pix_status')
      if (this.with_client_portfolios) keys.push('client_portfolio')
      if (this.with_client) keys.push('client')
      if (this.with_date_start) keys.push('date_start')
      if (this.with_date_end) keys.push('date_end')
      if (this.with_sellers) keys.push('sellers')
      if (this.with_company) keys.push('company')
      if (this.with_brand) keys.push('brand')
      if (this.with_bank) keys.push('bank')
      if (this.with_payment_option) keys.push('payment_option')
      if (this.with_envelope_number) keys.push('envelope_number')
      if (this.with_text_search) keys.push('text_search')
      return keys
    },
    pickerStartMin() {
      if (this.start_date_min != null && this.start_date_min !== '') return this.start_date_min
      return this.min_limit_date_start
    },
    pickerStartMax() {
      if (this.start_date_max != null && this.start_date_max !== '') return this.start_date_max
      return this.limit_date_start || this.today
    },
    pickerEndMin() {
      if (this.end_date_min != null && this.end_date_min !== '') return this.end_date_min
      return this.limit_date_end || this.date_start
    },
    pickerEndMax() {
      if (this.end_date_max != null && this.end_date_max !== '') return this.end_date_max
      return this.max_limit_date_end
    },
    dateFieldRules() {
      if (this.skip_date_range_rule) return []
      return [
        () => this.$moment(this.date_end).diff(this.$moment(this.date_start), 'months', true) <= 12 || 'Selecione um intervalo máximo de 12 meses.',
      ]
    },
    wich_banks(){
      if (this.with_company_banks){
        return this.company_banks
      }
      return this.banks
    },
    limit_three_months(){

      const start = this.$moment(this.date_start);
      const end = this.$moment(this.date_end);

      // Verifica se a diferença é de no máximo 3 meses
      const isWithin3Months = end.diff(start, 'months', true) <= 3;

      if (!isWithin3Months) {
        console.log('Intervalo maior que 3 meses!');
      } else {
        console.log('Intervalo válido!');
      }
    },
    loaded_all() {
      return Object.values(this.loading).every(v=> !v)
    },
    loaded_some() {
      return Object.values(this.loading).some(v=> v)
    },
    today(){
      return new Date().toISOString().substr(0, 10)
    },
  },
  watch: {
    billSituationValue: {
      deep: true,
      handler() {
        this.syncSituationModelsFromProps()
      },
    },
    exchangeSituationValue: {
      deep: true,
      handler() {
        this.syncSituationModelsFromProps()
      },
    },
    depositSituationValue: {
      deep: true,
      handler() {
        this.syncSituationModelsFromProps()
      },
    },
    vrtSituationValue: {
      deep: true,
      handler() {
        this.syncSituationModelsFromProps()
      },
    },
    activeModalityId(nv,ov) {
      if (nv){
        this.resetItems()
        this.getNeededData()
        // Reemite filtros limpos para o pai não manter portfolio_id (ou outros)
        // de outro módulo após a troca.
        this.$nextTick(() => {
          this.emitFilterPayload()
        })
      }
    },
    selected_clients(nv,ov) {
      if (nv){
        if (!nv[0] && nv[1]){
          this.selected_clients.splice(0,1)
        }
        if (nv.length && nv.length > 1 && !nv[nv.length-1]){
          this.selected_clients = [null]
        }
      }
    },
    selected_sellers(nv,ov) {
      if (nv){
        if (!nv[0] && nv[1]){
          this.selected_sellers.splice(0,1)
        }
        if (nv.length && nv.length > 1 && !nv[nv.length-1]){
          this.selected_sellers = [null]
        }
      }
    },
    selected_banks(nv,ov) {
      if (nv){
        if (!nv[0] && nv[1]){
          this.selected_banks.splice(0,1)
        }
        if (nv.length && nv.length > 1 && !nv[nv.length-1]){
          this.selected_banks = [null]
        }
      }
    },
    selected_brands(nv,ov) {
      if (nv){
        if (!nv[0] && nv[1]){
          this.selected_brands.splice(0,1)
        }
        if (nv.length && nv.length > 1 && !nv[nv.length-1]){
          this.selected_brands = [null]
        }
      }
    },
  },
}
</script>

<style scoped>
.filter-data-card {
  position: relative;
  z-index: 1;
  margin-bottom: 24px;
  border-color: rgba(0, 0, 0, 0.08) !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #fafbfc 100%);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04), 0 4px 24px rgba(0, 0, 0, 0.04) !important;
}

.filter-data-head {
  align-items: flex-start;
  padding: 16px 20px 8px;
}

@media (min-width: 960px) {
  .filter-data-head {
    align-items: center;
    padding: 18px 24px 10px;
  }
}

.filter-data-title {
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.3;
}

.filter-data-subtitle {
  font-size: 0.8125rem;
  margin-top: 2px;
  line-height: 1.35;
}

.filter-data-divider {
  opacity: 0.55;
}

.filter-data-btn {
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: none;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.28) !important;
}

/* Campos outlined mais compactos e consistentes */
.filter-data-card >>> .v-input--dense .v-label {
  font-size: 0.875rem;
}
</style>
